/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

export const setSelectedProductVariant = createAction('products/setSelectedProductVariant');

export const reducer = (builder) => {
  builder
    .addCase(setSelectedProductVariant, (state, { payload }) => {
      const { productId, variantId } = payload;
      const product = state.items.find(({ _id }) => _id === productId);

      if (product) product.selectedVariantId = variantId || null;
    });
};
